export const LOAD_LOCATIONS_BEGIN = "LOAD_LOCATIONS_BEGIN";
export const loadLocationsBegin = (search) => ({
  type: LOAD_LOCATIONS_BEGIN,
  search,
});

export const LOAD_LOCATIONS_FAILED = "LOAD_LOCATIONS_FAILED";
export const loadLocationsFailed = (error) => ({
  type: LOAD_LOCATIONS_FAILED,
  error,
});

export const LOAD_LOCATIONS_SUCCESS = "LOAD_LOCATIONS_SUCCESS";
export const loadLocationsSuccess = (locations) => ({
  type: LOAD_LOCATIONS_SUCCESS,
  locations,
});

export const CLEAR_LOCATIONS = "CLEAR_LOCATIONS";
export const clearLocations = () => ({
  type: CLEAR_LOCATIONS,
});
